export const BlogListingSkeleton = ({ count = 8 }) => {
  return (
    <div className="grid lg:grid-cols-2 gap-6 mt-[68px] w-full">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-[#1a1a1a]/50 rounded-xl w-full h-[494px] animate-pulse"
        >
          {/* Banner area */}
          <div className="bg-[#222222] rounded-t-xl w-full h-[271px]"></div>

          {/* Text content area */}
          <div className="space-y-4 p-6">
            <div className="bg-[#222222] rounded w-3/4 h-6"></div>
            <div className="bg-[#2b2b2b] rounded w-1/2 h-4"></div>

            <div className="bg-[#333333] my-4 w-full h-[1px]"></div>

            <div className="flex items-center gap-3">
              <div className="bg-[#2a2a2a] rounded-full w-[36px] h-[36px]"></div>
              <div className="flex flex-col gap-2">
                <div className="bg-[#2a2a2a] rounded w-[120px] h-4"></div>
                <div className="bg-[#2a2a2a] rounded w-[180px] h-3"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
